<template lang="pug">
  include ./../../../mixins
  div(style='display: flex')
    +b.burger-menu(
      @click.prevent='toggleMenu'
      :class="vision ? 'active': 'close'"
    )
      +b.DIV
      +b.DIV
      +b.DIV
    +b.drawer(
      :class="vision ? 'drawer--isactive': 'drawer--inactive'"
    )
      +e.overlay(
        :class="vision ? 'drawer__overlay--isactive': 'drawer__overlay--inactive'"
      )
      +e.sidebar(
        :class="vision ? 'drawer__sidebar--isactive' : 'drawer__sidebar--inactive'"
      )
        slot()
</template>

<script>
import scrollLock from 'scroll-lock';

export default {
  name: 'HeaderMenuCommon',
  props: {
    collapsable: {
      default: () => false,
    },
  },
  data() {
    return {
      viewBox: '0 0 22 19',
      widthSvg: '22',
      heightSvg: '19',
      vision: false,
    }
  },

  methods: {
    toggleMenu() {
      const $modalScroll = document.querySelector('.wrap-header')
      this.vision = !this.vision
      if (this.vision) {
        scrollLock.disablePageScroll($modalScroll);
      } else {
        scrollLock.enablePageScroll($modalScroll)
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// ./src/js/components/app/UiElements/HeaderMenuCommon.vue